import { Inject, Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Store, select } from "@ngrx/store";
import { catchError, combineLatest, filter, first, Observable, of, timeout } from "rxjs";
import { LocalServiceService } from "src/app/shareModule/services/local-service.service";
import { clearBizShopBanner, loadBizShopBanner, selectBizShopBanner, selectBizShopBannerLoading } from "src/app/shareModule/states/biz-shop-banner";
import { loadBizShopProducts, selectBizShopProductsLoading, selectProductState } from "src/app/shareModule/states/biz-shop-product";

@Injectable({
  providedIn: "root",
})
export class MarketplaceShopDetailResolver implements Resolve<any> {
  constructor(private store: Store, private local: LocalServiceService, @Inject('WINDOW') private window: any) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    const shopId = route.paramMap.get('shop');

    if (shopId) {
      // Dispatch actions to load the data
      this.store.dispatch(loadBizShopProducts({
        categoryId: '',
        subCategoryId: '',
        adminId: shopId,
        search: '',
        page: 1,
        limit: this.window.innerWidth > 991 ? 15 : 6
      }));

      this.store.dispatch(clearBizShopBanner());
      this.store.dispatch(loadBizShopBanner({ adminId: shopId }));

      return combineLatest([
        this.store.select(selectBizShopProductsLoading).pipe(filter((loaded) => !loaded)),
        this.store.select(selectBizShopBannerLoading).pipe(filter((loaded) => !loaded)),
      ]).pipe(
        first(),
        timeout(10000),
        catchError((err) => {
          console.error("Resolver timed out");
          return of([]);
        })
      );
    }

    // Fallback if no shop ID is provided
    return of([]);
  }
}
